import { useState, useRef, useCallback } from "react";

// ── INITIAL CLICKS DATA ───────────────────────────────────────
const INITIAL_CLICKS = [
  { id: 1,  src: "/Gallery/Img1.jpeg",  caption: "Inovaantage Team Collaboration",        tag: "Team" },
  { id: 2,  src: "/Gallery/Img2.jpeg",  caption: "Company All-Hands Meeting",              tag: "Events" },
  { id: 3,  src: "/Gallery/Img3.jpeg",  caption: "Leadership Strategy Session",            tag: "Events" },
  { id: 4,  src: "/Gallery/Img4.jpg",   caption: "Team Building Workshop",                 tag: "Team" },
  { id: 5,  src: "/Gallery/Img5.jpeg",  caption: "Product Demo Day",                       tag: "Events" },
  { id: 6,  src: "/Gallery/Img6.jpeg",  caption: "Office Culture Moment",                  tag: "Office" },
  { id: 7,  src: "/Gallery/Img7.jpeg",  caption: "Client Engagement Session",              tag: "Events" },
  { id: 8,  src: "/Gallery/Img8.jpeg",  caption: "Inovaantage UK Team",                    tag: "Team" },
  { id: 9,  src: "/Gallery/Img9.jpg",   caption: "Engineering Sprint Day",                 tag: "Team" },
  { id: 11, src: "/Gallery/Img11.jpeg", caption: "Award Recognition Ceremony",             tag: "Awards" },
  { id: 12, src: "/Gallery/Img12.jpg",  caption: "Inovaantage Singapore Office",           tag: "Office" },
  { id: 13, src: "/Gallery/Img13.jpg",  caption: "India Operations Team",                  tag: "Team" },
  { id: 14, src: "/Gallery/Img14.jpeg", caption: "APAC Leadership Summit",                 tag: "Events" },
  { id: 15, src: "/Gallery/Img15.jpeg", caption: "ISO 27001 Certification Achievement",    tag: "Awards" },
  { id: 16, src: "/Gallery/Img16.jpg",  caption: "GIS Platform Go-Live",                   tag: "Milestones" },
  { id: 17, src: "/Gallery/Img17.jpg",  caption: "New Office Launch",                      tag: "Office" },
  { id: 18, src: "/Gallery/Img18.jpg",  caption: "Cross-Team Collaboration",               tag: "Team" },
  { id: 19, src: "/Gallery/Img19.jpeg", caption: "Inovaantage at Industry Conference",     tag: "Events" },
  { id: 20, src: "/Gallery/Img20.jpeg", caption: "Client Success Milestone",               tag: "Milestones" },
  { id: 21, src: "/Gallery/Img21.jpeg", caption: "Training & Development Day",             tag: "Team" },
  { id: 22, src: "/Gallery/Img22.jpeg", caption: "Annual Company Gathering",               tag: "Events" },
  { id: 23, src: "/Gallery/Img23.jpeg", caption: "rUNr Migration Go-Live",                 tag: "Milestones" },
  { id: 24, src: "/Gallery/Img24.jpg",  caption: "Malaysia Office Team",                   tag: "Office" },
  { id: 25, src: "/Gallery/Img25.jpg",  caption: "ESRI Partner Recognition",               tag: "Awards" },
  { id: 26, src: "/Gallery/Img26.jpg",  caption: "Philippines Operations Team",            tag: "Team" },
  { id: 27, src: "/Gallery/Img27.jpeg", caption: "Utility Network Project Launch",         tag: "Milestones" },
  { id: 28, src: "/Gallery/Img28.jpeg", caption: "Innovation Workshop",                    tag: "Events" },
  { id: 29, src: "/Gallery/Img29.jpeg", caption: "Global Expansion Announcement",          tag: "Milestones" },
  { id: 30, src: "/Gallery/Img30.jpeg", caption: "ConduitPro Product Launch",              tag: "Milestones" },
  { id: 31, src: "/Gallery/Img31.jpg",  caption: "Team Offsite & Bonding",                 tag: "Team" },
  { id: 32, src: "/Gallery/Img32.jpeg", caption: "Australia Partnership Signing",          tag: "Milestones" },
  { id: 33, src: "/Gallery/Img33.jpeg", caption: "Inovaantage HQ — United Kingdom",        tag: "Office" },
  { id: 34, src: "/Gallery/Img34.jpeg", caption: "Community & CSR Initiative",             tag: "Events" },
  { id: 35, src: "/Gallery/Img35.jpeg", caption: "Year End Celebration 2025",              tag: "Events" },
];

const ALL_TAGS = ["All", "Team", "Events", "Milestones", "Office", "Awards"];

// ── VIDEOS DATA ──────────────────────────────────────────────
const videos = [
  { id: 1, thumb: "https://img.youtube.com/vi/9qtEpYqXPJ8/hqdefault.jpg",  title: "Inovaantage In GIS",          duration: "3:42", embed: "https://www.youtube.com/embed/9qtEpYqXPJ8" },
  { id: 2, thumb: "https://img.youtube.com/vi/bAGyaFFB26M/hqdefault.jpg",  title: "Inovaantage Introduction",             duration: "5:18", embed: "https://www.youtube.com/embed/bAGyaFFB26M" },
  { id: 3, thumb: "https://img.youtube.com/vi/bfKJFQ0ZRcM/hqdefault.jpg",  title: "Inovaantage Featured in ET Now- Greatest Brand & Leaders",             duration: "4:55", embed: "https://www.youtube.com/embed/bfKJFQ0ZRcM" },
  { id: 4, thumb: "https://img.youtube.com/vi/UFoVbNdgdCc/hqdefault.jpg",  title: "Inovaantage 2022",                 duration: "2:30", embed: "https://www.youtube.com/embed/UFoVbNdgdCc" },
  { id: 5, thumb: "https://img.youtube.com/vi/mYAeiqe7QjY/hqdefault.jpg",  title: "Navigating the Digital Age",      duration: "6:10", embed: "https://www.youtube.com/embed/mYAeiqe7QjY" },
  { id: 6, thumb: "https://img.youtube.com/vi/oYqRpjBtTvA/hqdefault.jpg",  title: "NEWSMAKERS | Dr. Sukanta Kumar Jena and Ms. Kirti Jena | Inovaantage |",           duration: "4:05", embed: "https://www.youtube.com/embed/oYqRpjBtTvA" },
  {
    id: 7,
    thumb: "https://img.youtube.com/vi/lXWf1FK9IWM/hqdefault.jpg",
    title: "Transforming Communities. Shaping Tomorrow. Inovaantage",
    duration: "3:23",
    embed: "https://www.youtube.com/embed/lXWf1FK9IWM"
  }
];

// ── POSTERS DATA ─────────────────────────────────────────────
const posters = [
  { id: 1, color: "#00d4ff", icon: "⚡", title: "Ungrid",           sub: "Unify Your Grid. Unlock Operational Clarity.",       tag: "Product" },
  { id: 2, color: "#00b8a0", icon: "🔌", title: "ConduitPro®",      sub: "Master Conduit Complexity at Scale.",                tag: "Product" },
  { id: 3, color: "#4facfe", icon: "🚀", title: "rUNr®",            sub: "Migrate with Certainty. Operate with Confidence.",   tag: "Product" },
  { id: 4, color: "#f7971e", icon: "🔋", title: "Energize",         sub: "Safe, Compliant Network Switching.",                 tag: "Product" },
  { id: 5, color: "#f093fb", icon: "🗺️", title: "Geospatial",       sub: "Precision Spatial Intelligence for Networks.",       tag: "Service" },
  { id: 6, color: "#43e97b", icon: "☁️", title: "Managed Services", sub: "Expert-Led. Continuous. Measurable.",               tag: "Service" },
];

// ── PRESS DATA ───────────────────────────────────────────────
const press = [
  { id: 1, date: "April 2026",     source: "Utility Week",               url: "https://utilityweek.co.uk",                title: "Inovaantage Reaches 50M Asset Migration Milestone with rUNr®",               excerpt: "The UK-based technology firm announces a landmark achievement in GIS data migration, with zero critical failures across all deployments." },
  { id: 2, date: "March 2026",     source: "Geospatial World",            url: "https://geospatialworld.net",             title: "Inovaantage Named Top Utility GIS Partner by ESRI Globally",                  excerpt: "ESRI recognises Inovaantage as a premier implementation partner for ArcGIS Utility Network across three continents." },
  { id: 3, date: "February 2026",  source: "Telecom Asia",                url: "https://telecomasia.net",                 title: "ConduitPro® Deployed Across Three New Telecom Operators in Southeast Asia",   excerpt: "The underground duct management platform sees accelerating adoption among tier-1 operators managing large-scale FTTP rollouts." },
  { id: 4, date: "January 2026",   source: "Smart Energy International",  url: "https://www.smart-energy.com",            title: "Inovaantage Partners with Major Australian Distributor for Grid Modernisation", excerpt: "A multi-year agreement covering GIS platform migration, digital twin deployment, and managed services across 1.8 million assets." },
  { id: 5, date: "November 2025",  source: "Infrastructure Intelligence", url: "https://www.infrastructure-intelligence.com", title: "Inovaantage Expands into US Market with New York Office Opening",            excerpt: "The global expansion follows successful delivery programmes in the UK, Australia, and Southeast Asia, bringing Inovaantage to 9+ countries." },
  { id: 6, date: "September 2025", source: "Electric Light & Power",      url: "https://www.elp.com",                     title: "How rUNr® Is Redefining Enterprise GIS Migration for Utilities",              excerpt: "An in-depth feature on Inovaantage's proprietary migration platform and its impact on utility digital transformation timelines." },
];

// ── LIGHTBOX ─────────────────────────────────────────────────
function Lightbox({ item, type, onClose }) {
  if (!item) return null;
  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-box" onClick={e => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>✕</button>
        {type === "image" && (
          <>
            <img src={item.dataUrl || item.src} alt={item.caption} className="lightbox-img" />
            <div className="lightbox-caption">
              <span className="lightbox-tag">{item.tag}</span>
              <p>{item.caption}</p>
            </div>
          </>
        )}
        {type === "video" && (
          <>
            <div className="lightbox-video-wrap">
              <iframe src={item.embed + "?autoplay=1"} title={item.title} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />
            </div>
            <div className="lightbox-caption"><p>{item.title}</p></div>
          </>
        )}
        {type === "poster" && (
          <div className="lightbox-poster" style={{ "--accent": item.color }}>
            <span className="lightbox-poster-icon">{item.icon}</span>
            <span className="lightbox-poster-tag" style={{ color: item.color }}>{item.tag}</span>
            <h2 style={{ color: item.color }}>{item.title}</h2>
            <p>{item.sub}</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ── ADD / EDIT MODAL ─────────────────────────────────────────
function ImageModal({ editItem, onSave, onClose, existingTags }) {
  const [caption, setCaption] = useState(editItem?.caption || "");
  const [tag, setTag]         = useState(editItem?.tag || "");
  const [src, setSrc]         = useState(editItem?.src || "");
  const [dataUrl, setDataUrl] = useState(editItem?.dataUrl || null);
  const [dragging, setDragging] = useState(false);
  const fileRef = useRef();

  const readFile = useCallback((file) => {
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setDataUrl(e.target.result);
      if (!caption) setCaption(file.name.replace(/\.[^.]+$/, "").replace(/[-_]/g, " "));
    };
    reader.readAsDataURL(file);
  }, [caption]);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    readFile(e.dataTransfer.files[0]);
  };

  const handleSave = () => {
    if (!caption.trim()) return;
    onSave({
      ...(editItem || {}),
      caption: caption.trim(),
      tag: tag.trim() || "General",
      src: src.trim(),
      dataUrl: dataUrl || editItem?.dataUrl || null,
    });
  };

  const preview = dataUrl || src;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{editItem?.id ? "Edit image" : "Add image"}</h3>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        {/* Drop zone */}
        <div
          className={`drop-zone${dragging ? " dragover" : ""}`}
          onDragOver={e => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={handleDrop}
          onClick={() => fileRef.current.click()}
        >
          {preview
            ? <img src={preview} alt="preview" className="drop-preview" />
            : (
              <div className="drop-placeholder">
                <span className="drop-icon">📁</span>
                <span>Drop an image here or <u>browse</u></span>
                <span className="drop-hint">JPG, PNG, GIF, WebP</span>
              </div>
            )
          }
        </div>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={e => readFile(e.target.files[0])}
        />

        <div className="modal-fields">
          <label>
            Caption / name *
            <input
              type="text"
              value={caption}
              onChange={e => setCaption(e.target.value)}
              placeholder="e.g. Team offsite 2025"
            />
          </label>
          <label>
            Category tag
            <input
              type="text"
              value={tag}
              onChange={e => setTag(e.target.value)}
              placeholder="Team, Events, Office…"
              list="tag-suggestions"
            />
            <datalist id="tag-suggestions">
              {existingTags.map(t => <option key={t} value={t} />)}
            </datalist>
          </label>
          <label>
            File path / URL <span className="optional">(optional if uploading)</span>
            <input
              type="text"
              value={src}
              onChange={e => setSrc(e.target.value)}
              placeholder="/gallery/Img36.jpeg"
            />
          </label>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={handleSave} disabled={!caption.trim()}>
            {editItem?.id ? "Save changes" : "Add image"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── GALLERY MANAGER (ClicksPage) ─────────────────────────────
function ClicksPage() {
  const [images, setImages]       = useState(INITIAL_CLICKS);
  const [nextId, setNextId]       = useState(100);
  const [lightbox, setLightbox]   = useState(null);
  const [filter, setFilter]       = useState("All");
  const [search, setSearch]       = useState("");
  const [viewMode, setViewMode]   = useState("grid"); // "grid" | "list"
  const [selected, setSelected]   = useState(new Set());
  const [modal, setModal]         = useState(null);    // null | { mode: "add" | "edit", item }
  const bulkFileRef               = useRef();

  // ── derived tags from current images
  const dynamicTags = ["All", ...Array.from(new Set(images.map(i => i.tag))).sort()];

  // ── filtered list
  const filtered = images.filter(img => {
    const matchTag = filter === "All" || img.tag === filter;
    const q = search.toLowerCase();
    const matchQ = !q || img.caption.toLowerCase().includes(q) || img.tag.toLowerCase().includes(q) || (img.src || "").toLowerCase().includes(q);
    return matchTag && matchQ;
  });

  // ── selection helpers
  const toggleSelect = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };
  const clearSelected = () => setSelected(new Set());

  // ── CRUD
  const handleAdd = (data) => {
    const id = nextId;
    setNextId(n => n + 1);
    setImages(prev => [...prev, { id, ...data }]);
    setModal(null);
  };

  const handleEdit = (data) => {
    setImages(prev => prev.map(img => img.id === data.id ? { ...img, ...data } : img));
    setModal(null);
  };

  const handleDelete = (id) => {
    setImages(prev => prev.filter(img => img.id !== id));
    setSelected(prev => { const n = new Set(prev); n.delete(id); return n; });
  };

  const handleBulkDelete = () => {
    setImages(prev => prev.filter(img => !selected.has(img.id)));
    clearSelected();
  };

  // ── bulk file upload (multiple images at once)
  const handleBulkFiles = (files) => {
    Array.from(files).forEach((file, i) => {
      if (!file.type.startsWith("image/")) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        setImages(prev => {
          const id = nextId + i;
          return [...prev, {
            id,
            src: "",
            dataUrl: e.target.result,
            caption: file.name.replace(/\.[^.]+$/, "").replace(/[-_]/g, " "),
            tag: "General",
          }];
        });
        setNextId(n => n + files.length);
      };
      reader.readAsDataURL(file);
    });
  };

  const imgSrc = (item) => item.dataUrl || item.src || "";

  return (
    <div className="subpage-root">
      {/* Hero */}
      <section className="subpage-hero" style={{ "--accent": "#00d4ff" }}>
        <div className="subpage-hero-badge">
          <span className="subpage-icon">📸</span>
          <span>Gallery</span>
        </div>
        <h1 className="subpage-title">Inovaantage Clicks</h1>
        <p className="subpage-tagline">Moments that define our culture, our people, and our journey.</p>
      </section>

      <section className="subpage-section">
        <div className="subpage-container">

          {/* ── Manager toolbar ── */}
          <div className="manager-toolbar">
            {/* Search */}
            <div className="manager-search-wrap">
              <span className="manager-search-icon">🔍</span>
              <input
                type="text"
                className="manager-search"
                placeholder="Search images…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>

            {/* Actions */}
            <div className="manager-actions">
              {/* Bulk upload */}
              {/* <button
                className="mgr-btn mgr-btn-outline"
                onClick={() => bulkFileRef.current.click()}
                title="Upload multiple images at once"
              >
                ⬆ Upload
              </button> */}
              <input
                ref={bulkFileRef}
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
                onChange={e => handleBulkFiles(e.target.files)}
              />

              {/* Add single */}
              {/* <button className="mgr-btn mgr-btn-primary" onClick={() => setModal({ mode: "add", item: null })}>
                + Add image
              </button> */}

              {/* View toggle */}
              <div className="view-toggle">
                <button
                  className={`view-toggle-btn${viewMode === "grid" ? " active" : ""}`}
                  onClick={() => setViewMode("grid")}
                  title="Grid view"
                >⊞</button>
                <button
                  className={`view-toggle-btn${viewMode === "list" ? " active" : ""}`}
                  onClick={() => setViewMode("list")}
                  title="List view"
                >☰</button>
              </div>
            </div>
          </div>

          {/* ── Stats row ── */}
          <div className="manager-stats">
            <span className="mgr-stat"><strong>{images.length}</strong> total</span>
            <span className="mgr-stat-sep">·</span>
            <span className="mgr-stat"><strong>{filtered.length}</strong> showing</span>
            <span className="mgr-stat-sep">·</span>
            <span className="mgr-stat"><strong>{dynamicTags.length - 1}</strong> categories</span>
            {selected.size > 0 && (
              <>
                <span className="mgr-stat-sep">·</span>
                <span className="mgr-stat selected-count">
                  <strong>{selected.size}</strong> selected
                  {/* //<button className="bulk-delete-btn" onClick={handleBulkDelete}>Delete selected</button> */}
                  <button className="clear-sel-btn" onClick={clearSelected}>Clear</button>
                </span>
              </>
            )}
          </div>

          {/* ── Filter tabs ── */}
          <div className="gallery-filters">
            {dynamicTags.map(t => (
              <button
                key={t}
                className={"gallery-filter-btn" + (filter === t ? " active" : "")}
                onClick={() => setFilter(t)}
              >{t}</button>
            ))}
          </div>

          {/* ── Grid / List view ── */}
          {filtered.length === 0 && (
            <div className="gallery-empty">
              <span>🖼️</span>
              <p>No images found. Try a different search or tag.</p>
            </div>
          )}

          {viewMode === "grid" && filtered.length > 0 && (
            <div className="clicks-grid">
              {filtered.map(item => {
                const isSelected = selected.has(item.id);
                const src = imgSrc(item);
                return (
                  <div
                    key={item.id}
                    className={"click-card" + (isSelected ? " click-card-selected" : "")}
                    onClick={() => toggleSelect(item.id)}
                  >
                    {/* Checkbox indicator */}
                    <div className={"click-checkbox" + (isSelected ? " checked" : "")}>
                      {isSelected ? "✓" : ""}
                    </div>

                    <div className="click-img-wrap">
                      {src
                        ? <img
                            src={src}
                            alt={item.caption}
                            onError={e => {
                              e.target.style.display = "none";
                              e.target.nextSibling.style.display = "flex";
                            }}
                          />
                        : null
                      }
                      <div className="click-placeholder" style={{ display: src ? "none" : "flex" }}>
                        <span>📸</span>
                        <span style={{ fontSize: "0.75rem", marginTop: 4 }}>{item.caption}</span>
                      </div>
                      <div className="click-overlay">
                        <button
                          className="click-action-btn"
                          onClick={e => { e.stopPropagation(); setLightbox(item); }}
                          title="View"
                        >🔍 View</button>
                        
                      </div>
                    </div>
                    <div className="click-caption">
                      <span className="click-tag">{item.tag}</span>
                      <p>{item.caption}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {viewMode === "list" && filtered.length > 0 && (
            <div className="clicks-list">
              {filtered.map(item => {
                const isSelected = selected.has(item.id);
                const src = imgSrc(item);
                return (
                  <div
                    key={item.id}
                    className={"list-row" + (isSelected ? " list-row-selected" : "")}
                    onClick={() => toggleSelect(item.id)}
                  >
                    <div className={"click-checkbox small" + (isSelected ? " checked" : "")}>
                      {isSelected ? "✓" : ""}
                    </div>
                    {src
                      ? <img src={src} alt={item.caption} className="list-thumb"
                          onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                      : null
                    }
                    <div className="list-thumb-ph" style={{ display: src ? "none" : "flex" }}>📸</div>
                    <div className="list-meta">
                      <strong className="list-caption">{item.caption}</strong>
                      {/* <span className="list-src">{item.src || "(local upload)"}</span> */}
                    </div>
                    <span className="click-tag">{item.tag}</span>
                    <div className="list-actions" onClick={e => e.stopPropagation()}>
                      <button className="list-icon-btn" onClick={() => setLightbox(item)} title="View">🔍</button>
                      <button className="list-icon-btn" onClick={() => setModal({ mode: "edit", item })} title="Edit">✏️</button>
                      {/* <button className="list-icon-btn danger" onClick={() => handleDelete(item.id)} title="Delete">🗑</button> */}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <Lightbox item={lightbox} type="image" onClose={() => setLightbox(null)} />
      )}

      {/* Add / Edit Modal */}
      {modal && (
        <ImageModal
          editItem={modal.item}
          existingTags={dynamicTags.filter(t => t !== "All")}
          onSave={modal.mode === "add" ? handleAdd : handleEdit}
          onClose={() => setModal(null)}
        />
      )}
    </div>
  );
}

// ── HERO (shared) ─────────────────────────────────────────────
function GalleryHero({ title, icon, tagline }) {
  return (
    <section className="subpage-hero" style={{ "--accent": "#00d4ff" }}>
      <div className="subpage-hero-badge">
        <span className="subpage-icon">{icon}</span>
        <span>Gallery</span>
      </div>
      <h1 className="subpage-title">{title}</h1>
      <p className="subpage-tagline">{tagline}</p>
    </section>
  );
}

// ── VIDEOS PAGE ───────────────────────────────────────────────
function VideosPage() {
  const [lightbox, setLightbox] = useState(null);
  return (
    <div className="subpage-root">
      <GalleryHero icon="🎬" title="Inovaantage Videos" tagline="Watch our product demos, company highlights, and client success stories." />
      <section className="subpage-section">
        <div className="subpage-container">
          <div className="videos-grid">
            {videos.map(v => (
              <div key={v.id} className="video-card" onClick={() => setLightbox(v)}>
                <div className="video-thumb-wrap">
                  <img src={v.thumb} alt={v.title} />
                  <div className="video-play-btn">▶</div>
                  <span className="video-duration">{v.duration}</span>
                </div>
                <div className="video-info">
                  <p className="video-title">{v.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {lightbox && <Lightbox item={lightbox} type="video" onClose={() => setLightbox(null)} />}
    </div>
  );
}

// ── POSTERS PAGE ──────────────────────────────────────────────
function PostersPage() {
  const [lightbox, setLightbox] = useState(null);
  return (
    <div className="subpage-root">
      <GalleryHero icon="🖼️" title="Inovaantage Posters" tagline="Visual brand assets, product highlights, and campaign materials." />
      <section className="subpage-section">
        <div className="subpage-container">
          <div className="posters-grid">
            {posters.map(p => (
              <div key={p.id} className="poster-card" style={{ "--accent": p.color }} onClick={() => setLightbox(p)}>
                <div className="poster-visual" style={{ background: `radial-gradient(circle at 30% 40%, ${p.color}30 0%, transparent 70%)` }}>
                  <span className="poster-icon">{p.icon}</span>
                  <div className="poster-expand-hint">🔍 Click to expand</div>
                </div>
                <div className="poster-body">
                  <span className="poster-tag" style={{ color: p.color }}>{p.tag}</span>
                  <h3 style={{ color: "var(--text-primary)" }}>{p.title}</h3>
                  <p style={{ color: "var(--text-secondary)" }}>{p.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {lightbox && <Lightbox item={lightbox} type="poster" onClose={() => setLightbox(null)} />}
    </div>
  );
}

// ── PRESS PAGE ────────────────────────────────────────────────
function PressPage() {
  return (
    <div className="subpage-root">
      <GalleryHero icon="📰" title="Press Release" tagline="Latest news, media coverage, and official announcements from Inovaantage." />
      <section className="subpage-section">
        <div className="subpage-container">
          <div className="press-grid">
            {press.map(p => (
              <article key={p.id} className="press-card">
                <div className="press-meta">
                  <span className="press-source">{p.source}</span>
                  <span className="press-date">{p.date}</span>
                </div>
                <h2 className="press-title">{p.title}</h2>
                <p className="press-excerpt">{p.excerpt}</p>
                <a
                  href={p.url || "mailto:info@inovaantage.com"}
                  target={p.url ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className="press-read-btn"
                >Read Full Release →</a>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

// ── ROUTER ────────────────────────────────────────────────────
export default function GalleryPage({ page }) {
  if (page === "gallery-clicks")  return <ClicksPage />;
  if (page === "gallery-videos")  return <VideosPage />;
  if (page === "gallery-posters") return <PostersPage />;
  if (page === "gallery-press")   return <PressPage />;

  return (
    <div className="subpage-root">
      <GalleryHero icon="🖼️" title="Gallery" tagline="Explore our visual story — photos, videos, posters and press." />
      <section className="subpage-section">
        <div className="subpage-container">
          <div className="gallery-landing-grid">
            {[
              { id: "gallery-clicks",  icon: "📸", label: "Inovaantage Clicks",  desc: "Team photos, events & milestones", color: "#00d4ff" },
              { id: "gallery-videos",  icon: "🎬", label: "Inovaantage Videos",  desc: "Product demos & company films",    color: "#f7971e" },
              { id: "gallery-posters", icon: "🖼️", label: "Inovaantage Posters", desc: "Brand & campaign visuals",         color: "#f093fb" },
              { id: "gallery-press",   icon: "📰", label: "Press Release",        desc: "News & media coverage",           color: "#43e97b" },
            ].map(item => (
              <div key={item.id} className="gallery-landing-card" style={{ "--accent": item.color }}>
                <span className="gallery-landing-icon">{item.icon}</span>
                <h3 style={{ color: "var(--text-primary)" }}>{item.label}</h3>
                <p style={{ color: "var(--text-secondary)" }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

/*
──────────────────────────────────────────────────────────────
  ADD THESE STYLES TO YOUR CSS FILE (e.g. GalleryPage.css)
──────────────────────────────────────────────────────────────

  -- Manager toolbar --

  .manager-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .manager-search-wrap {
    position: relative;
    flex: 1;
    min-width: 200px;
  }
  .manager-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
  }
  .manager-search {
    width: 100%;
    padding: 8px 12px 8px 34px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
  }
  .manager-search:focus { border-color: #00d4ff; }
  .manager-actions { display: flex; gap: 8px; align-items: center; }
  .mgr-btn {
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    border: none;
  }
  .mgr-btn-outline {
    background: #fff;
    border: 1px solid #ddd;
    color: #444;
  }
  .mgr-btn-outline:hover { background: #f5f5f5; }
  .mgr-btn-primary { background: #00d4ff; color: #fff; }
  .mgr-btn-primary:hover { background: #00b8d9; }
  .view-toggle { display: flex; border: 1px solid #ddd; border-radius: 8px; overflow: hidden; }
  .view-toggle-btn { padding: 7px 12px; background: #fff; border: none; cursor: pointer; font-size: 16px; }
  .view-toggle-btn.active { background: #f0f0f0; }

  -- Stats row --

  .manager-stats {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #666;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }
  .mgr-stat strong { color: #111; }
  .mgr-stat-sep { color: #ccc; }
  .selected-count { display: flex; align-items: center; gap: 8px; }
  .bulk-delete-btn {
    padding: 3px 10px;
    background: #ff4444;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    cursor: pointer;
  }
  .clear-sel-btn {
    padding: 3px 10px;
    background: #eee;
    color: #555;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    cursor: pointer;
  }

  -- Card selection state --

  .click-card { position: relative; cursor: pointer; }
  .click-card-selected { outline: 2px solid #00d4ff; }
  .click-checkbox {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid rgba(255,255,255,0.7);
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
  .click-checkbox.checked { background: #00d4ff; border-color: #00d4ff; }

  -- Overlay action buttons --

  .click-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.45);
    opacity: 0;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  .click-img-wrap:hover .click-overlay { opacity: 1; }
  .click-action-btn {
    padding: 6px 10px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.4);
    border-radius: 6px;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }
  .click-action-btn:hover { background: rgba(255,255,255,0.3); }
  .click-action-del { border-color: rgba(255,80,80,0.6); }
  .click-action-del:hover { background: rgba(255,60,60,0.4); }

  -- List view --

  .clicks-list { display: flex; flex-direction: column; gap: 6px; }
  .list-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border: 1px solid #eee;
    border-radius: 10px;
    cursor: pointer;
    background: #fff;
    transition: background 0.15s;
  }
  .list-row:hover { background: #f9f9f9; }
  .list-row-selected { outline: 2px solid #00d4ff; }
  .list-thumb {
    width: 60px;
    height: 44px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
  }
  .list-thumb-ph {
    width: 60px;
    height: 44px;
    border-radius: 6px;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
  }
  .list-meta { flex: 1; min-width: 0; }
  .list-caption { display: block; font-size: 14px; color: #111; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .list-src { display: block; font-size: 12px; color: #999; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .list-actions { display: flex; gap: 6px; }
  .list-icon-btn {
    padding: 5px 8px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
  }
  .list-icon-btn:hover { background: #f5f5f5; }
  .list-icon-btn.danger { border-color: #ffcdd2; }
  .list-icon-btn.danger:hover { background: #ffebee; }

  -- Empty state --

  .gallery-empty {
    text-align: center;
    padding: 60px 20px;
    color: #aaa;
  }
  .gallery-empty span { font-size: 40px; display: block; margin-bottom: 12px; }

  -- Add / Edit Modal --

  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-box {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    width: min(480px, 94vw);
    max-height: 90vh;
    overflow-y: auto;
  }
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .modal-header h3 { font-size: 18px; font-weight: 600; color: #111; }
  .modal-close-btn { background: none; border: none; font-size: 18px; cursor: pointer; color: #888; }
  .drop-zone {
    border: 2px dashed #ddd;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 16px;
    transition: border-color 0.2s;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .drop-zone.dragover { border-color: #00d4ff; }
  .drop-zone:hover { border-color: #aaa; }
  .drop-preview { max-height: 180px; max-width: 100%; border-radius: 8px; object-fit: contain; }
  .drop-placeholder { display: flex; flex-direction: column; gap: 6px; color: #999; font-size: 14px; }
  .drop-icon { font-size: 32px; }
  .drop-hint { font-size: 12px; color: #bbb; }
  .modal-fields { display: flex; flex-direction: column; gap: 14px; }
  .modal-fields label { display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #555; font-weight: 500; }
  .modal-fields input {
    padding: 9px 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    color: #111;
  }
  .modal-fields input:focus { border-color: #00d4ff; }
  .optional { font-weight: 400; color: #bbb; font-size: 12px; }
  .modal-footer { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }
  .btn-secondary {
    padding: 9px 18px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #fff;
    color: #555;
    font-size: 14px;
    cursor: pointer;
  }
  .btn-primary {
    padding: 9px 18px;
    border: none;
    border-radius: 8px;
    background: #00d4ff;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
  .btn-primary:not(:disabled):hover { background: #00b8d9; }

──────────────────────────────────────────────────────────────
*/
